<template>
  <transition name="fade">
    <div
      v-if="show"
      :class="{ 'notification-success': notificationType==1, 'notification-warning': notificationType==2, 'notification-danger': notificationType==3, 'notification-info': notificationType==4  }"
      class="notification mb-3  px-lg-5 px-3 py-3 animate__animated animate__fadeIn"
    >
      <div class="d-flex align-items-md-center">
        <i
          v-if="notificationType==1"
          class="far fa-lg fa-check-circle mr-3 color-1"
        ></i> <i
          v-if="notificationType==2"
          class="far fa-lg fa-exclamation-circle mr-3 text-warning"
        ></i> <i
          v-if="notificationType==3"
          class="far fa-lg fa-times-circle mr-3 text-danger"
        ></i> <i
          v-if="notificationType==4"
          class="far fa-lg fa-info-circle mr-3 text-info"
        ></i>
        {{notificationMessage}}
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  mounted() {
    this.show = true;
  },
  data() {
    return {
      show: false,
    };
  },
};
</script>
